<template>
    <div class="tablelist">
        <a-table
            size="middle"
            :key="this.loading.key"
            :columns="columns"
            :rowKey="record => record.id"
            :dataSource="list"
            :pagination="false"
            :loading="this.loading.effects[selectType] || this.loading.effects[deleteType]"
        >
            <template slot="operation" slot-scope="text,record">
                <router-link
                    class="mr10"
                    :to="{
                    path:'edit',
                    query: {
                        id: record.id,
                        //这里注意this的作用域指向问题
                        referer: JSON.stringify(that.$route.query),
                    }
                }"
                >编辑</router-link>
                <a-popconfirm title="确认删除?" @confirm="() => onDelete(record)">
                    <a :disabled="that.loading.effects[deleteType]" href="javascript:;">删除</a>
                </a-popconfirm>
            </template>
        </a-table>
        <v-pageinfo v-if="pagination.total > 0" :pagination="pagination"></v-pageinfo>
    </div>
</template>

<script>
import { mapState } from "vuex";

const storeNamespace = "rc";

const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => ++index
    },
    {
        title: "服务KEY",
        dataIndex: "servicekey"
    },
    {
        title: "规则内容",
        dataIndex: "rulecontent"
    },
    {
        title: "黑名单",
        dataIndex: "nlflag",
        width: 80,
        customRender: text => (text == "1" ? "是" : "否")
    },
    {
        title: "名单类型",
        dataIndex: "nltype",
        customRender: text => {
            switch (text) {
                case "0":
                    return "黑名单";
                case "1":
                    return "白名单";
                case "2":
                    return "接口黑名单";
                case "3":
                    return "接口白名单";
                default:
                    return "未知类型";
            }
        }
    },
    {
        title: "添加黑名单时间",
        dataIndex: "nlinterval"
    },
    {
        title: "创建时间",
        dataIndex: "createtime"
    },
    {
        title: "操作",
        width: 146,
        scopedSlots: { customRender: "operation" }
    }
];
export default {
    data() {
        return {
            that: this,
            storeNamespace,
            selectType: `${storeNamespace}/select`,
            deleteType: `${storeNamespace}/del`,
            columns
        };
    },
    methods: {
        //删除
        onDelete(record) {
            this.$store.dispatch({
                type: this.deleteType,
                params: record
            });
        }
    },
    computed: {
        ...mapState(storeNamespace, {
            list: state => state.list,
            pagination: state => {
                return state.pagination;
            }
        })
    },
    mounted() {
        this.$store.dispatch({
            type: this.selectType
        });
    }
};
</script>
<style lang="less" scoped>
</style>
